import { render, staticRenderFns } from "./Recoil.vue?vue&type=template&id=af4b05e0"
import script from "./Recoil.vue?vue&type=script&lang=js"
export * from "./Recoil.vue?vue&type=script&lang=js"
import style0 from "./Recoil.vue?vue&type=style&index=0&id=af4b05e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports